interface TocItem {
  id: string;
  text: string;
}

interface ArticleAsideProps {
  toc: TocItem[];
  articleId: string;
  author: string;
  date: string;
  readTime: number;
  views: string;
  heat: string;
  status: string;
  tags: string[];
}

export default function ArticleAside({
  toc,
  articleId,
  author,
  date,
  readTime,
  views,
  heat,
  status,
  tags,
}: ArticleAsideProps) {
  return (
    <div className="flex flex-col gap-5">
      {toc.length > 0 && (
        <nav
          className="rounded-lg border border-background-200 bg-background-100/70 p-5 md:p-6"
          aria-label="目录"
        >
          <h2 className="text-xs tracking-[0.25em] text-primary-500 mb-4">本页目录</h2>
          <ol className="space-y-3">
            {toc.map((item, index) => (
              <li key={item.id}>
                <a
                  href={`#${item.id}`}
                  className="flex gap-3 text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer leading-relaxed"
                >
                  <span className="text-xs text-foreground-500 pt-0.5">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  {item.text}
                </a>
              </li>
            ))}
          </ol>
        </nav>
      )}

      <div className="rounded-lg border border-background-200 bg-background-100/70 p-5 md:p-6">
        <h2 className="text-xs tracking-[0.25em] text-primary-500 mb-4">档案信息</h2>
        <dl className="space-y-3 text-sm">
          <div className="flex items-center justify-between gap-4">
            <dt className="text-foreground-600 text-xs">档案编号</dt>
            <dd className="text-foreground-900">{articleId}</dd>
          </div>
          <div className="flex items-center justify-between gap-4">
            <dt className="text-foreground-600 text-xs">整理人</dt>
            <dd className="text-foreground-900">{author}</dd>
          </div>
          <div className="flex items-center justify-between gap-4">
            <dt className="text-foreground-600 text-xs">入库时间</dt>
            <dd className="text-foreground-900">{date}</dd>
          </div>
          <div className="flex items-center justify-between gap-4">
            <dt className="text-foreground-600 text-xs">预计阅读</dt>
            <dd className="text-foreground-900">{readTime} 分钟</dd>
          </div>
          <div className="flex items-center justify-between gap-4">
            <dt className="text-foreground-600 text-xs">阅读量</dt>
            <dd className="text-foreground-900">{views}</dd>
          </div>
          <div className="flex items-center justify-between gap-4">
            <dt className="text-foreground-600 text-xs">热度</dt>
            <dd className="text-accent-500">{heat}</dd>
          </div>
        </dl>
        <div className="mt-5 pt-5 border-t border-background-200">
          <span className="text-[11px] tracking-widest stamp-tag inline-block px-3 py-1.5 rounded-full">
            {status}
          </span>
        </div>
      </div>

      {tags.length > 0 && (
        <div className="rounded-lg border border-background-200 bg-background-100/70 p-5 md:p-6">
          <h2 className="text-xs tracking-[0.25em] text-primary-500 mb-4">相关标签</h2>
          <div className="flex flex-wrap gap-2">
            {tags.map((tag) => (
              <span
                key={tag}
                className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="rounded-lg border border-dashed border-accent-500/40 bg-accent-500/5 p-5 md:p-6">
        <div className="flex items-center gap-2 text-xs tracking-widest text-accent-500 mb-3">
          <i className="ri-lightbulb-line"></i>
          补一条线索
        </div>
        <p className="text-sm text-foreground-600 leading-relaxed">
          如果你手上有更完整的材料，欢迎投递到档案室邮箱，核对入库后会标注贡献者编号。
        </p>
      </div>
    </div>
  );
}